import { Box, FormHelperText, InputAdornment } from '@material-ui/core';
import React from 'react';
import * as Yup from 'yup';

import { FormBodyAPI } from 'src/constants';
import BaseTypography from 'src/legacy/components/Text/BaseTypography';
import { BaseTextField } from 'src/legacy/components/TextField';

const validationScheme = Yup.object().shape({
  id: Yup.string().required(),
  fromAmount: Yup.number()
    .typeError('Micro-deposit amount must be a number')
    .required('Micro-deposit amount cannot be empty'),
  toAmount: Yup.number()
    .typeError('Micro-deposit amount must be a number')
    .required('Micro-deposit amount cannot be empty'),
});

export const useBankVerifyForm = () => {
  const FormRenderer: React.FC<FormBodyAPI> = ({
    values,
    touched,
    errors,
    handleBlur,
    handleChange,
  }) => (
    <>
      <Box mb={2}>
        <img
          src="/images/deposit_preview.png"
          alt="Verify bank example"
          width="100%"
        />
      </Box>
      <Box mb={2}>
        <BaseTypography>
          To verify your bank account please enter the 2 micro-deposits sent to{' '}
          <strong>
            {values.bank_name} ending in {values.last4}
          </strong>
          . These transactions should arrive 1-2 business days after you connect
          your bank.
        </BaseTypography>
      </Box>
      <Box
        display="flex"
        alignItems="center"
        maxWidth="240px"
        justifyContent="space-between"
      >
        <Box mr={2}>
          <BaseTypography fontType="13Medium">Amounts</BaseTypography>
        </Box>
        <Box maxWidth="82px">
          <BaseTextField
            error={Boolean(touched.fromAmount && errors.fromAmount)}
            label=""
            id="from-amount-input"
            name="fromAmount"
            onBlur={handleBlur}
            onChange={handleChange}
            value={values.fromAmount}
            variant="outlined"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">$0.</InputAdornment>
              ),
            }}
          />
        </Box>
        <Box maxWidth="82px">
          <BaseTextField
            error={Boolean(touched.toAmount && errors.toAmount)}
            label=""
            id="to-amount-input"
            name="toAmount"
            onBlur={handleBlur}
            onChange={handleChange}
            value={values.toAmount}
            variant="outlined"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">$0.</InputAdornment>
              ),
            }}
          />
        </Box>
      </Box>
      <FormHelperText error>
        {(touched.toAmount && errors.toAmount) ||
          (touched.fromAmount && errors.fromAmount)}
      </FormHelperText>
    </>
  );

  return { validationScheme, FormRenderer };
};
